// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1Kf9V","title":"Images90_title__36_Sf","images":"Images90_images__37JFL"};